import Vue from 'vue'
import $wss from "./wss";
import '../plugins/element'
import Router from 'vue-router'
import router from '../router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
import {
    Notification
} from "element-ui";
export default {
    ws: '',
    user_type: '',
    user_id: '',
    doctor: [],
    doc_id: '',
    usered: '',
    text: {},
    is_state: 0,
    is_have_noread: false,
    timer: null,
    noread:'',
    async openws() {
        let that = this
        let userinfo = JSON.parse(sessionStorage.getItem('user'))
        let wssUrl = (document.domain == 'manager.kkxxkj.cn') ? 'wss://api.kkxxkj.cn/admin/wss' : 'wss://api.kkxxkj.cn/admin/wss'
        // let wssUrl = (document.domain == 'manager.kkxxkj.cn') ? 'wss://api.kkxxkj.cn/admin/wss' : 'ws://kuaikang-api-dev.com:8012/admin/wss'
        //实例
        that.ws = $wss.ws(wssUrl + '?type=admin&token=' + `manager_${userinfo.token}`);

        // that.ws = $wss.ws('ws://crmeb.jskwsx.com/ws/index/server/indexKt?token=' + `manager_${userinfo.token}`);
        that.ws.join = function (e) {
            // console.log(e.Info,'join');
            // console.log(e);
            that.user_type = e.Info.user_type; //自己的type
            that.user_id = e.Info.user_id;
            that.usered = e.Info.bindUser[0]
            that.doctor = e.Info.bindUser
            that.doc_id = e.Info.bindUser[0].id
        };
        that.ws.onopen = function () {
            // that.ws.send('index/server/ping');
            that.ws.send({
                type: "ping"
            });
            that.timer = setInterval(function () {
                // that.ws.send('index/server/ping');
                that.ws.send({
                    type: "ping"
                });

                // console.log( that.ws.getState());
                // if (that.ws.getState()!=1) {
                //     that.ws.close()
                //     setTimeout(async () => {
                //         await that.openws()
                //         await that.connect()
                //     }, 500)
                // }


                console.log('当前状态:', that.ws.getState());
                if (that.ws.getState() != 1) {
                    console.log(new Date(+new Date() + 8 * 3600 * 1000).toJSON().substr(0, 19).replace("T", " ") + '-----断开');
                    that.is_state = 0
                    that.ws.close()
                    clearInterval(that.timer)
                    that.timer = null
                    setTimeout(() => {
                        that.openws()
                        console.log(new Date(+new Date() + 8 * 3600 * 1000).toJSON().substr(0, 19).replace("T", " ") + '-----重连');
                        that.is_state = 1
                        that.connect()
                    }, 500)
                }
            }, 1000 * 30);
            // that.ws.send('index/server/user', `manager_${userinfo.token}`);

        }
        that.ws()
    },
    async getover(source, type) {
        let vue = this
        await axios.post('/admin/pc/KfChat/offlineMessage', {
            // user_id: this.doc_id
            source: source
        }, {
            token: true
        }).then(async (res) => {
            let noreads = res.data.data
            vue.doctor.forEach(ele => {
                for (const k in noreads) {
                    if (ele.id == noreads[k].id) {
                        ele.no_read = noreads[k].no_read ? noreads[k].no_read : ''
                    }
                }
            });

            let isn = false
            vue.doctor.forEach(ele => {
                if (ele.no_read && ele.no_read > 0) {
                    isn = true;
                    return
                }
            })
            if (isn) {
                vue.is_have_noread = true
            } else {
                vue.is_have_noread = false
            }
            if (noreads.length>0 && noreads[0].no_read && noreads[0].no_read > 0 && type != 'clear') {
                Notification.info({
                    title: '新信息提醒',
                    message: noreads[0].nickname + '专家有' + noreads[0].no_read + '条新信息',
                    position: 'bottom-right'
                });
            }
        })
    },
    async connect(source, t) {
        let vue = this
        vue.ws.homePage = function (text, type) {
            console.log('后台监听');
            // console.log(text);
            if (text.modular == 'audit' || text.modular == 'pretax' || text.modular == 'mallDeliver') {
                Notification.info({
                    title: '新待处理',
                    message: '有新待处理事务，请及时处理(点击查看)',
                    position: 'bottom-right',
                    onClick: () => {
                        router.push('/index')
                    }
                });
            }
        };
        vue.ws.system = function (text, type) {
            Notification.info({
                title: '新系统通知',
                message: text.content,
                position: 'bottom-right',
            });
            vue.getxinxi()
        };
        // 接诊提醒
        vue.ws.inquiryRemind = function (text, type) {
            Notification.info({
                title: '新咨询订单',
                message: text.data,
                position: 'bottom-right',
            });
        };

        /*vue.ws.msg = async function (user_id, kefu_id, text) {
            vue.text = text
            if (text.xx_type != 'self') {
                await vue.getover(source, '')
            }
            if (text.msg_source=='homePage') {
                if (text.modular=='audit'||text.modular=='pretax'||text.modular=='mallDeliver') {
                    Notification.info({
                        title: '新待处理',
                        message: '有新待处理事务，请及时处理(点击查看)',
                        position: 'bottom-right',
                        onClick:() =>{
                            router.push('/index')
                        }
                    });
                }
            }
        };*/
        if (t == 1) {
            await vue.getover(source, '')
        }
    },
    getxinxi() {
        let vue = this
        axios.post('/admin/SystemActivity/getLatest', {}, {
            token: true
        }).then(res => {
            vue.noread = res.data.data.notification.no_read == 0 ? '' : res.data.data.notification.no_read
        })
    },
}